import Work1 from "../../assets/work1.png";
import Work2 from "../../assets/work2.png";
import Work3 from "../../assets/work3.png";
import Work4 from "../../assets/work4.png";
import Work5 from "../../assets/work5.png";
import Work6 from "../../assets/work6.png";
import Work7 from "../../assets/work7.png";
import Work8 from "../../assets/work8.png";


export const projectsData = [
    {
      id: 1,
      image: Work1,
      title: "My Portfolio",
      category: "web",
      url: "https://github.com/kumkumshh/my-portfolio",
    },
    {
      id: 2,
      image: Work2,
      title: "Movie Recommender System",
      category: "ml",
      url: "https://moviefinderrr.streamlit.app/",
    },
    {
      id: 3,
      image: Work3,
      title: "Rock Paper Scissor",
      category: "pp",
      url: "https://github.com/kumkumshh/rock-paper-scissors",
    },
    {
      id: 4,
      image: Work4,
      title: "Car Price Prediction",
      category: "ml",
      url: "https://github.com/kumkumshh/car-price-project",
    },
    {
      id: 5,
      image: Work5,
      title: "Static Food Website",
      category: "pp",
      url: "https://github.com/kumkumshh/static-food-website",
    },
    {
      id: 6,
      image: Work6,
      title: "Real-Time ChatApp",
      category: "web",
      url: "https://github.com/kumkumshh/chatApp",
    },
    {
      id: 7,
      image: Work7,
      title: "Fine Dine Restro",
      category: "web",
      url: "https://kumkumshh.github.io/fine-dine-restaurant-web/",
    }, 
    {
      id: 8,
      image: Work8,
      title: "Track My Expenses",
      category: "web",
      url: "https://github.com/kumkumshh/Track-My-Expenses",
    },   
  ];

  export const projectsNav = [
    {
        name: 'all',
    },
    {
        name: 'web',
    },
    {
        name: 'ML',
    },
    {
        name: 'PP',
    },
  ];